// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__ihYbu","productName":"Table_productName__21Hcb"};